module.exports = __webpack_public_path__ + "media/images/city/025-walled-obelisk-5cc0aa03c63df067503e7704508a81b4.svg";